var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fixed-header',[_c('div',{staticClass:"navbar"},[_c('div',{staticClass:"header"},[_c('img',{staticClass:"header-img",attrs:{"src":"/build/images/eucom_logo_simplu.svg"}}),_c('h2',{attrs:{"id":"countdown_header"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }